import { Component, OnInit } from '@angular/core';
import { BaseAPIService } from '../Services/api.base.service';
import { ICoolersList } from '../Models/ICoolersList';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { UtilService } from '@app/Services/util.service';
import { ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownConfig } from '../Models/IDeviceMetadata';

@Component({
  selector: 'app-export',
  standalone: false,
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss'],
  providers: [MessageService]
})
export class ExportComponent implements OnInit {
  labels: any;
  messages: any;
  startDate: Date;
  endDate: Date;
  maxDateValue: Date;
  minDateValue: Date;
  coolerDrpdwnConfig: IDropdownConfig;
  coolersList: ICoolersList[];
  coolersListE: ICoolersList[];
  selectedReportType: string;
  coolerNames: ICoolersList[] = [];
  clist: ICoolersList[];
  isLoading: boolean;
    response: any;
  today: Date;
  contentHeader: string;
  modalReference: NgbModalRef;
  closeResult: string;
  modalOptions: NgbModalOptions;
  currentPercentage: number = 0;
  downloadedFiles: number = 0;
  request: any;
  tempArray: any = [];
  totalFiles: number = 0;
  totalSize: number = 0;
  obsList: any = [];
  Progress_dailog: boolean = false;
  showWarningmodal: boolean = false;
  size: string;
  constructor(private readonly baseService: BaseAPIService, 
    private readonly messageService: MessageService, private readonly translate: TranslateService) { }

  ngOnInit() {
    this.labels = label;
    this.messages = message;
    this.selectedReportType = 'Json';
    this.GetCoolersData();
    this.today = new Date();
    this.maxDateValue = this.today;
    this.isLoading = false;
    this.coolerDrpdwnConfig = {
      displayKey: "value",
      search: true,
      height: '200px',
      placeholder: this.translate.instant(this.labels.select)
    }
    this.modalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      windowClass: 'modal-xl'
    };
  }
  GetCoolersData() {
    this.baseService.GET('/Alarm/Devices').subscribe((result: ICoolersList[]) => {
      if (result !== null && result.length > 0) {
        this.coolersList = result;
        this.coolersListE = result;
      }
    });
  }

  checkRange() {
    if (this.startDate) {
      const sdate = this.startDate;
      const a = UtilService.FormatDate(sdate);
      const b = UtilService.FormatDate(this.today);
      if (!this.endDate && (a !== b)) {
        this.endDate = new Date(sdate.getFullYear(), sdate.getMonth(), sdate.getDate() + 1);
      } 
      this.maxDateValue = new Date(sdate.getFullYear(), sdate.getMonth(), sdate.getDate() - 1 + environment.NumberOfdays);
      if (this.startDate > this.endDate) {
        this.endDate = UtilService.FormatDate(this.startDate) === UtilService.FormatDate(this.today) ? this.startDate : new Date(sdate.getFullYear(), sdate.getMonth(), sdate.getDate() + 1);
      } else if (this.startDate && this.endDate) {
        const diff = UtilService.GetDateDifference(this.startDate, this.endDate);
        if (diff >= environment.NumberOfdays) {
          this.endDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate() + 1);
        }
      }
    }
  }

  CoolerNameSelectionChanged($event: Event) {
    if (this.coolerNames.length === 0) {
      this.coolersList = this.coolersListE;
    }
  }

  getDLFCountV2() {
    this.downloadedFiles = 0;
    this.totalFiles = 0;
    this.currentPercentage = 0;
    if (this.startDate === null || this.startDate === undefined) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidStartDate), detail: this.translate.instant(this.messages.selectStartDate), key: 'error' });
    } else if (this.endDate === null || this.endDate === undefined) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidEndDate), detail: this.translate.instant(this.messages.selectEndDate), key: 'error' });
    } else if (this.coolerNames.length === 0) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidDevice), detail: this.translate.instant(this.messages.selectDevice), key: 'error' });
    } else {
      this.request = {
        'FromDate': UtilService.FormatDate(this.startDate),
        'ToDate': UtilService.FormatDate(this.endDate),
        'DeviceIds': this.coolerNames
      };
      this.isLoading = true;
      this.baseService.PostWithHeaders('/Data/FilesDetails', {}, this.request)
        .subscribe((results: any[]) => {
          this.response = results;
          this.totalFiles = results.length;
          if (this.totalFiles === 0) {
            this.isLoading = false;
            this.messageService.add({ severity: 'warn', summary: this.translate.instant(this.messages.warning), detail: this.translate.instant(this.messages.noFiles), key: 'error' });
            return;
          }
          this.totalSize = 0;
          this.response.forEach((item) => {
            this.totalSize += item.fileSize;
          });
          this.size = this.formatBytes(this.totalSize);
          this.showWarningmodal = true;
          this.SplitArray(this.response, environment.ChunkSize);
          this.isLoading = false;
        }, (error) => {
          console.log(error);
        });
    }
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  ExportJSONV2() {
    this.showWarningmodal = false;
    this.obsList = [];
    this.messageService.clear('c');
    this.contentHeader = this.labels.progressBar;
    this.Progress_dailog = true;
    if (this.tempArray) {
      for (let i = 0; i < this.tempArray.length; i++) {
        const CoolersReq = [];
        for (let j = 0; j < this.tempArray[i].length; j++) {
          CoolersReq.push(this.tempArray[i][j]);
          const dongleUId = CoolersReq[j].dongleUId;
          const fileName = CoolersReq[j].fileName;
           this.baseService.GET(`/Data/Export/${dongleUId}/${fileName}`).subscribe((result: any) => {
            if (result !== null) {
              const jsonse = JSON.stringify(result);
              const blob = new Blob([jsonse], { type: 'application/json' });
              saveAs(blob, fileName);
              this.downloadedFiles = this.downloadedFiles + 1;
              this.getCurentPercentage();
            }
          });
        }
      }
    }
  }


  getCurentPercentage() {
    this.currentPercentage = (this.downloadedFiles / this.totalFiles) * 100;
    if (this.currentPercentage === 100) {
      this.Progress_dailog = false;
      this.messageService.add({ severity: 'success', summary: this.translate.instant('Success'), detail: this.translate.instant(this.messages.downloadsSuccess), key: 'success' });
    }

  }
  SplitArray(arr: Array<any>, size: number) {
    const arrayLength = arr.length;
    this.tempArray = [];
    for (let index = 0; index < arrayLength; index += size) {
      const myChunk = arr.slice(index, index + size);
      this.tempArray.push(myChunk);
    }
    return this.tempArray;
  }
  onReject() {
    this.messageService.clear('c');
  }

  getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return 'by pressing ESC';
      case ModalDismissReasons.BACKDROP_CLICK:
        return 'by clicking on a backdrop';
      default:
        return `with: ${reason}`;
    }
  }
  rejectmd() {
    for (let i = 0; i < this.obsList.length; i++) {
      this.obsList[i].unsubscribe();
    }
    this.Progress_dailog = false;
    this.messageService.add({ severity: 'warn', summary: this.translate.instant(this.messages.warning), detail: this.translate.instant(this.messages.downloadsCancelled), key: 'error' });
  }

  public close() {
    this.showWarningmodal = false;
  }
}
